import {
  AUTH_TOKEN,
  LATITUDE,
  LONGITUDE,
  PREFERRED_DELIVERY_AREA,
  SELECTED_ADDRESS_ID,
  STORE_INFO,
} from "../constants";

export const getCookie = (name: string): string | null | undefined => {
  if (typeof document !== "undefined") {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(";").shift();
    }
  }
  return null;
};

export const setCookie = (name: string, value: string, path = "/"): void => {
  document.cookie = `${name}=${value}; path=${path}`;
};

export const getUserIsLoggedIn = (): boolean => {
  return Boolean(getCookie(AUTH_TOKEN));
};

export const getStoreInfo = (): boolean => {
  return Boolean(getCookie(STORE_INFO));
};

export const setLatLong = (latitude: string, longitude: string): void => {
  setCookie(LATITUDE, latitude);
  setCookie(LONGITUDE, longitude);
};

export const setLocalSelectedAddressId = (addressId: string): void => {
  setCookie(SELECTED_ADDRESS_ID, addressId);
  localStorage.setItem(SELECTED_ADDRESS_ID, addressId);
};

export const setPreferredDeliveryArea = (
  value: string,
  storeId: string,
): void => {
  setCookie(`${storeId}-${PREFERRED_DELIVERY_AREA}`, value);
};
